import React, { FC } from "react";
import styled, { keyframes } from "styled-components";
import "./LoadingSpinner.css";
import largeAnimationData from '../../ModuleLoader.json';
import smallAnimationData from '../../SmallModuleLoader.json'
import Lottie from 'lottie-react';

const SpinnerOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

interface IModuleSpinnerProps {
  isLargeLoading?: boolean;
}

export const ModuleSpinner: FC<IModuleSpinnerProps> = ({ isLargeLoading }) => {
  const animationData = isLargeLoading ? largeAnimationData : smallAnimationData;
  return (
    <SpinnerOverlay className="spinner-overlay">
      <Lottie animationData={animationData} loop={true} style={{ width: 80, height: 80 }} />
    </SpinnerOverlay>
  );
};
